import { useEffect } from 'react';

export const imagesFromClipboard = (clipboardData: DataTransfer | null): File[] =>
  [...(clipboardData?.files ?? [])].filter(file => file.type.startsWith('image/'));

const isTextField = (target: EventTarget | null): boolean =>
  target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement;

export const usePastedImages = (enabled: boolean, onPaste: (files: File[]) => void) => {
  useEffect(() => {
    if (!enabled) return;
    const handlePaste = (event: ClipboardEvent) => {
      const images = imagesFromClipboard(event.clipboardData);
      if (images.length === 0 || isTextField(event.target)) return;
      event.preventDefault();
      onPaste(images);
    };
    document.addEventListener('paste', handlePaste);
    return () => document.removeEventListener('paste', handlePaste);
  }, [enabled, onPaste]);
};
